
import Vue from "vue"
import UserForm from "@/components/UserForm.vue"

export default Vue.extend({
  components: {
    UserForm
  },
})
